import { Injectable } from '@angular/core';
/// <reference path="../../typings/crypto-js/crypto-js.d.ts" />

/**
 * Module used for all type of encryption functionlaity
 *
 * @export
 * @class CryptoJSUtilityLib
 */

@Injectable()
export class CryptoJSUtilityLib {

    constructor() {
        //Do something
    }

    /**
     * Encode the string in BASE64
     *
     * @param {string} inputParam
     * @returns {string}
     *
     * @memberOf CryptoJSUtilityLib
     */
    encodeBASE64(inputParam: string): string {
        return btoa(inputParam);
    }

    /**
     * Decode the BASE64 string to normal string
     *
     * @param {string} inputParam
     * @returns {string}
     *
     * @memberOf CryptoJSUtilityLib
     */
    decodeBASE64(inputParam: string): string {
        return atob(inputParam);
    }
}
